import {useState} from "react";
import SimpleBar from "simplebar-react";
import {Box, Button, Checkbox, Typography, useMediaQuery} from "@mui/material"
import {Trans, useTranslation} from "react-i18next";
import 'simplebar-react/dist/simplebar.min.css';

import TransMsg from "./transMessage";
import {theme} from "../../utils";
import {useSnackbar} from "../../contexts";
import {CommonDialog} from "../dialog/CommonDialog";
import {IRedirectDialogProps, styles} from "./redirectDialog-helpers";


export const RedirectDialog = (props: IRedirectDialogProps) => {
    const {showDialog, onCloseRedirectDialog, vendorItem} = props
    const {t} = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down(950))

    const {showSnackbar} = useSnackbar();
    const [isChecked, setIsChecked] = useState(false)
    const handleOnDialogClose = () => {
        setIsChecked(false)
        if (onCloseRedirectDialog) {
            onCloseRedirectDialog()
        }
    };

    const onContinue = () => {
        handleOnDialogClose()
        const url = vendorItem?.redirectURL
        if (url) {
            if (isChecked) {
                const getCheckedVendors = localStorage.getItem("checkedVendors")
                const checkedVendorsList = getCheckedVendors ? JSON.parse(getCheckedVendors) : []
                const updatedVendors = [...checkedVendorsList, vendorItem?.vendorId];
                localStorage.setItem('checkedVendors', JSON.stringify(updatedVendors))
            }
            window.open(`https://${url}`, '_blank', 'noopener,noreferrer');
        } else {
            showSnackbar("redirect uri is not available!", "error")
        }
    };

    return (
        <CommonDialog
            isDialogVisible={showDialog}
            headerLabel={t(TransMsg.DIALOG_TITLE)}
            headerTitleSx={{ textAlign: "center" }}
            slotProps={{
                paper: {
                    sx: {
                        width: '614px',
                        maxWidth: '90%',
                    }
                }
            }}
            onDialogClose={handleOnDialogClose}>
            <Box>
                <Box pl={isMobile ? "20px" : "43px"} pr={isMobile ? "18px" : "60px"}>
                    <Typography sx={styles.leavingLabel}>
                        You are now leaving APP.HYPERCEPT-GA.COM
                    </Typography>

                    <SimpleBar style={{maxHeight: isMobile ? "250px" : "600px"}}>
                        <Box sx={styles.textBorder}>
                            <Typography sx={styles.infoMsgLabel}>
                                {vendorItem?.isSSOEnabled ?
                                    <Trans
                                        i18nKey={t(TransMsg.SSO_ENABLED_MSG)}
                                        values={{vendorName: vendorItem?.title}}
                                        components={{
                                            br: <br/>,
                                            ul: <ul style={{paddingLeft: '1.2em', marginTop: "0px"}}/>,
                                            li: <li/>,
                                            bold: <strong style={{fontWeight: "700"}}/>
                                        }}/>
                                    :
                                    <Trans
                                        i18nKey={t(TransMsg.NON_SSO_ENABLED_MSG)}
                                        values={{vendorName: vendorItem?.title}}
                                        components={{
                                            br: <br/>,
                                            ul: <ul style={{paddingLeft: '1.2em', marginTop: "0px"}}/>,
                                            li: <li/>,
                                            bold: <strong/>
                                        }}/>
                                }
                            </Typography>
                        </Box>
                    </SimpleBar>
                    <Box sx={{display: "flex", alignItems: "center", flexDirection: "row", mt: "25px"}}>
                        <Checkbox
                            value={isChecked}
                            size={"small"}
                            sx={{pl: "0px", color: "#DDDBDA"}}
                            onClick={() => setIsChecked(!isChecked)}/>
                        <Typography
                            sx={{
                                ...theme.typography.montseratBodyRegular,
                                fontSize: "13px",
                                textAlign: "left",
                                lineHeight: "16px",
                                fontWeight: 400,
                                letterSpacing: 0,
                                verticalAlign: "middle",
                            }}>
                            {t(TransMsg.CHECK_BOX_MSG)}
                        </Typography>
                    </Box>
                </Box>
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={isMobile ? "center" : "flex-end"}
                    alignItems={"center"}
                    flexWrap="wrap"
                    mt={'24px'}
                    mb="24px" gap={'16px'} sx={{pr: isMobile ? "0px" : "32px"}}>
                    <Button
                        onClick={handleOnDialogClose}
                        variant='outlined'
                        sx={[styles.footerBtnWrapper, {borderColor: "#404144", color: "#000"}]}>
                        <Typography sx={{
                            ...theme.typography.montseratH1,
                            fontSize: "14px",
                            color: "inherit"
                        }}>{t(TransMsg.CANCEL_AND_STAY_BTN)}</Typography>
                    </Button>
                    <Button
                        onClick={onContinue}
                        variant='contained'
                        sx={styles.footerBtnWrapper}>
                        <Typography
                            sx={styles.containedText}>{vendorItem?.isSSOEnabled ? t(TransMsg.CONTINUE_TO_EXTERNAL_SITE_BTN) : `Create ${vendorItem?.title} Account`}</Typography>
                    </Button>
                </Box>
            </Box>
        </CommonDialog>
    )
}